<script setup lang="ts">
const dropdownItems = [
  [{
    label: 'Documentation',
    to: 'https://help.sleuth.io/pulse/welcome-to-pulse-docs',
    target: '_blank',
    icon: 'regular:book',
  }, {
    label: 'Leave feedback',
    to: 'mailto:support@sleuth.io?subject=Pulse%20Feedback',
    icon: 'regular:message-smile',
  }],
]
</script>

<template>
  <div class="mt-auto">
    <UDropdown :items="dropdownItems" :ui="{ width: 'w-56' }" class="px-2">
      <UButton
        icon="regular:circle-question"
        variant="ghost"
        color="white-nav"
        class="!text-gray-500"
      />
    </UDropdown>
  </div>
</template>
